export default ["Africa","Arab States","Asia & Pacific","Europe","Middle east","North America","South/Latin America"]